<div class="order-progress-bar">
  <div class="progress-line">
    @for (step of steps; track step; let i = $index) {
      <div [class]="getStepClass(i)" [pTooltip]="step" tooltipPosition="top"></div>
    }
  </div>
  @if (currentStatusLabel) {
    <div class="status-label">{{ currentStatusLabel }}</div>
  }
</div>
